<template>
    <div>

        <menu-bar></menu-bar>

        <div class="container-fluid" role="main">
            <div class="row" style="margin-top: 50px">

                <div class="col-sm-3" >
                    <legend style="border-bottom: 3px solid #e5e5e5;!important;">ACESSOS</legend>
                    <div :key="index" v-for="(r, index) in comandos">
                        <notice :type="(r.bloqueado) ? 'warning' : 'success'" :title="r.status" v-if="r.status === 'ACESSO AUTORIZADO'">
                            <span style="font-size: 18px">{{ r.texto | truncate(35) }}</span><br/>
                            <small style="font-size: 13px; font-weight: bold;">{{ r.data | date('DD/MM/YYYY HH:mm:ss') }}</small>
                        </notice>
                        <notice v-else type="danger" :title="r.status">
                            <span style="font-size: 18px">{{ r.texto | truncate(35) }}</span><br/>
                            <small style="font-size: 15px; font-weight: bold;">{{ r.data | date('DD/MM/YYYY HH:mm:ss') }}</small>
                        </notice>
                    </div>
                </div>

                <div class="col-sm-9">
                    <div class="row">
                        <div class="col-sm-8" >
                            <div class="row">
                                <legend style="border-bottom: 3px solid #e5e5e5;!important;">LINKS</legend>
                                <card :key="index" v-for="(r, index) in servers" :tamanho="'col-md-3'" :image="url + 'image/conexao.png'" :title="r.title" :ip="r.ip" />
                            </div>
                            <div class="row">
                                <legend style="border-bottom: 3px solid #e5e5e5;!important;">CONCENTRADORES</legend>
                                <card v-if="r.ativo" :key="index" v-for="(r, index) in concentradores" :tamanho="'col-md-3'" :image="url + 'image/pops.png'" :title="r.nome" :ip="r.ssh.host" />
                            </div>
                        </div>
                        <div class="col-sm-4" >
                            <div class="row">
                            <legend style="border-bottom: 3px solid #e5e5e5;!important;">CLIENTES</legend>
                            <div class="col-xs-12 col-sm-8 col-md-6" v-if="counts">
                                <div class="mainflip">
                                    <div class="frontside">
                                        <div class="card" style="background-color: white; border: green solid 3px; padding: 10px;">
                                            <div class="card-body text-center">
                                                <p style="padding: 0px">
                                                    <img :src="url + 'image/online.png'" alt="card image">
                                                </p>
                                                <h1 class="card-title">
                                                    <b>ONLINE {{ counts.online }}</b>
                                                </h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-8 col-md-6" v-if="counts">
                                <div class="mainflip">
                                    <div class="frontside">
                                        <div class="card" style="background-color: white; border: #E57373 solid 3px; padding: 10px;">
                                            <div class="card-body text-center">
                                                <p style="padding: 0px">
                                                    <img :src="url + 'image/offline.png'" alt="card image">
                                                </p>
                                                <h1 class="card-title">
                                                    <b>OFFLINE {{ counts.offline }}</b>
                                                </h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <legend style="border-bottom: 3px solid #e5e5e5;!important;">POPS</legend>
                        <card :key="index" v-for="(r, index) in pops" :image="url + 'image/pops.png'" :id="r._id" :title="r.nome" :ips="r.ips" :ip="r.ip" />
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Notice from "../components/Notice";
import { date } from "../filters";
import { Concentrador, Pops, Contratos } from "../class/index";
import Card from "../components/Card";

export default {
    name: "Monitoramento",
    components: {
        Notice,
        Card
    },
    filters: {
        date
    },
    data() {
        return {
            comandos: [],
            counts: null,
            concentradores: [],
            servers: [
                {
                    ip: "200.160.0.8",
                    // ip: "177.47.131.99",
                    title: "VER TV",
                    icon: "link"
                },
                {
                    ip: "200.192.232.8",
                    // ip: "186.237.55.29",
                    title: "FORTE",
                    icon: "link"
                }
            ],
            pops: [],
            timer1: null,
            timer2: null,
            timer3: null
        };
    },
    computed: {
        url: function() {
            return this.$http.options.root;
        }
    },
    sockets: {
        // Fired when the server sends something on the "messageChannel" channel.
        auth(data) {
            try {
                this.comandos.unshift(data);
                if (this.comandos.length > 10) {
                    this.comandos.pop();
                }
            } catch (e) {
                console.log(e);
            }
        }
    },

    beforeMount() {
        // eslint-disable-next-line no-undef
        // this.socket = io.connect(this.$http.options.root, { reconnect: true, transports: ["websocket", "polling"] });

        // this.socket.on("connect", () => { // TIP: you can avoid listening on `connect` and listen on events directly too!
        this.$socket.emit("message", function(data) {
            console.log(data); // data will be 'woot'
        });
        // });

        this.timer1 = setInterval(() => {
            if (this.comandos.length > 10) {
                this.comandos.pop();
            }
        }, 60000);

        this.timer2 = setInterval(() => this.counOnOff(), 180000);
        this.timer3 = setInterval(() => location.reload(), 60000 * 30);

        this.loadConcentradores();
        this.loadPops();
        this.counOnOff();
    },

    beforeDestroy() {
        clearInterval(this.timer1);
        clearInterval(this.timer2);
        clearInterval(this.timer3);
    },

    methods: {
        async loadConcentradores() {
            this.concentradores = await Concentrador.all();
        },
        async loadPops() {
            this.pops = await Pops.all();
        },
        async counOnOff() {
            this.counts = await Contratos.countOnlineOffline();
        }
    }
};
</script>
<style scoped>
section {
    padding: 60px 0;
}

.card {
    border: none;
    border-radius: 5px;
    border-top-right-radius: 20px;
    background: #73ad21;
}

.image-flip:hover .frontside,
.image-flip.hover .frontside {
    -webkit-transform: rotateY(180deg);
    -moz-transform: rotateY(180deg);
    -o-transform: rotateY(180deg);
    transform: rotateY(180deg);
}

.mainflip {
    -webkit-transition: 1s;
    -webkit-transform-style: preserve-3d;
    transition: 1s;
    position: relative;
}

.frontside {
    position: relative;
    -webkit-transform: rotateY(0deg);
    -ms-transform: rotateY(0deg);
    z-index: 2;
    margin-bottom: 30px;
}

.frontside .card,
.backside .card {
    min-height: 112px;
}

.backside .card a {
    font-size: 18px;
    color: #007b5e !important;
}

.frontside .card .card-title,
.backside .card .card-title {
    color: #000 !important;
}

.frontside .card .card-body img {
    height: 57px;
    border-radius: 40%;
}
</style>
